<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
        :title="title"
        :small="true"
    >
      <slot name="load">

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>
      <p>{{text}}</p>
      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Nee</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="doYesClick()">Ja</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import {Component} from 'vue-property-decorator';
  import {
    // SVG
    warningIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import {deanDialogBus} from '@/main';

  @Component({
    components: {
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanDialogButtonGroup,
    },
  })

  export default class DeleteDialog extends Vue {
    // DATA
    public text: string = 'Weet u het zeker? Hiermee wordt deze prijsplanregel permanent verwijderd.';

    // COMPUTED
    get title() {
      return 'Prijsplan regel verwijderen?';
    }

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public doYesClick() {
      this.$emit('setLoad', true);

      this.$store.dispatch('deletePricePlanEntry', {
        id: this.$route.params.id,
        pricePlanId: this.$route.params.ppId,
      }).then(
        (response) => {
          deanDialogBus.$emit('deleteStatusChanged');
          this.close();
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
        },
      ).finally(() => {
        this.$emit('setLoad', false);
      });
    }

    public created() {
      this.$emit('setLoad', false);
    }

    public destroyed() {
      this.$emit('setLoad', false);
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

</style>
